export default __webpack_public_path__ + "static/media/tabletop.fe863295.png";